import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import RouterContainer from "./containers/RouterContainer";
import { TRPCProvider } from "./trpc/TRPCProvider";
import { StytchB2BProvider } from "@stytch/react/b2b";
import { StytchB2BUIClient } from "@stytch/vanilla-js/b2b";
import { MerchantContextProvider } from "./contexts/MerchantContext";
import { UserContextProvider } from "./contexts/UserContext";
import { RulesetContextProvider } from "./contexts/RulesetContext";
import { PipelineContextProvider } from "./contexts/PipelineContext";
import { useContext } from "react";
import MerchantContext from "./contexts/MerchantContext";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";

const stytch = new StytchB2BUIClient(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN);

const AppWithContexts = () => {
  const { merchantId } = useContext(MerchantContext);

  return (
    <RulesetContextProvider merchantId={merchantId}>
      <PipelineContextProvider>
        <WebSocketProvider>
          <RouterContainer />
        </WebSocketProvider>
        <Toaster />
      </PipelineContextProvider>
    </RulesetContextProvider>
  );
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary surface="root">
      <StytchB2BProvider stytch={stytch}>
        <TRPCProvider>
          <UserContextProvider>
            <MerchantContextProvider>
              <AppWithContexts />
            </MerchantContextProvider>
          </UserContextProvider>
        </TRPCProvider>
      </StytchB2BProvider>
    </ErrorBoundary>
  </StrictMode>
);
